import clsx from 'clsx';

import Icon from '../Icon';

type IconClearProps = {
  className?: string;
  onClick?: () => void;
};

const IconClear: React.FC<IconClearProps> = ({ className, onClick }) => {
  return (
    <Icon
      width
      icon="clear"
      onClick={onClick}
      className={clsx(
        className,
        'hover:[text-shadow:0_2px_4px_currentColor] transition-all',
        'text-small cursor-pointer'
      )}
    />
  );
};

export default IconClear;
